let _log = function () {
	if (typeof newrelic == "object" && typeof newrelic.noticeError == "function") {
		newrelic.noticeError(new Error('geolocation logging'), {data: [...arguments] });
	} else {
		// console.log([...arguments])
	}
};

const locate = () => {
	return new Promise( ( resolve, reject ) => {
		const fetchGeo = () => {
			fetch( '/wp-json/ccusa/v1/geolocation', { method: 'POST' } ).then( response => {
				if ( ! response.headers.get('content-type').split(';').map( p => p.trim() ).includes( 'application/json' ) ) {
					reject( 'Invalid geolocation content type' );
				}

				return response.json();
			} ).then( body => {
				if (isValid(body, 0)) {
					body.fetched = Date.now();
					sessionStorage.setItem( 'geolocation', JSON.stringify( body ) )
					resolve( body );
				} else {
					reject();
				}
			} ).catch( reject );
		}



		try {
			const geo = JSON.parse( sessionStorage.getItem( 'geolocation' ) );

			_log({ 'sessionStorage.gelocation': geo, 'isValid': isValid( geo ) } );

			if ( isValid( geo ) ) {
				resolve( geo );
			} else {
				_log('fetchGeo()');
				fetchGeo();
			}
		} catch (err) {
			_log(err);
			reject('busted');
			fetchGeo();
		}
	} );
}

let isValid = (data, cacheDuration = 600) => {
	// no lat/long
	if (!data || !data.longitude || !data.latitude) {
		_log('// no lat/long');
		return false;
	}

	// only need to check lat/lng so return if cacheduration is zero
	if (cacheDuration == 0) {
		return true;
	}

	// no fetched date
	if (!data.fetched) {
		_log('// no fetched date');
		return false;
	}

	// has cache expired
	if ((Date.now() - data.fetched) / 1000 > cacheDuration) {
		_log('// cache expired: ' + cacheDuration );
		return false;
	}

	return true;
}

const getDistance = ( distance ) => {
	const fixedDistance = parseFloat( distance.toFixed(1) );
	const label = 1 === fixedDistance ? 'mile' : 'miles';

	return `${fixedDistance} ${label}`;
}

const geo = {
	locate,
	isValid,
	getDistance,
}

export default geo;
